<ng-content>
    <span>{{ selectedLanguage() | sonaLanguage | translate }}</span>
    <sona-icon hlmMenuIcon name="caret-down" size="small" class="tw-ml-2 tw-mr-0" />
</ng-content>

<ng-template #languageMenu>
    <hlm-menu>
        <hlm-menu-group>
            @for (language of languages; track language) {
                <button hlmMenuItemRadio [checked]="language === selectedLanguage()" (triggered)="changeLanguage(language)">
                    <hlm-menu-item-radio />
                    <span>{{ language | sonaLanguage | translate }}</span>
                </button>
            }
        </hlm-menu-group>
    </hlm-menu>
</ng-template>